const INTERNAL_EMAIL_DOMAIN = '@capquest.io';

// Convenience gate for internal-only debug affordances (e.g. copying a company id for bug
// reports). Never use it for authorization — the server re-checks every request.
export const isInternalCapQuestEmail = (email: null | string | undefined): boolean =>
  Boolean(email?.trim().toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN));
